import axios from 'axios'
import React, { useState } from 'react'
import { Button, Glyphicon } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Select from 'react-select'

import { swalError, swalSuccess } from '../../../common/components/Swaler'

const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

type Props = {
  closeAddCarrierBox: Function,
  vendors: [
    {
      _id: String,
      email: String,
      name: String,
    }
  ],
}

const AddCarrierBox = ({ closeAddCarrierBox, vendors }: Props) => {
  const [email, setEmail] = useState('')
  const [organization, setOrganization] = useState('')
  const [password, setPassword] = useState('')
  const [fileData, setFileData] = useState()
  const [selectedVendors, setSelectedVendors] = useState([])
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const addCarrier = async () => {
    setLoading(true)

    const body = {
      email,
      organization,
      password,
      vendors: selectedVendors.map((v) => v.value),
    }

    if (fileData) {
      await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(fileData)
        reader.onload = () => {
          body.image = reader.result
          resolve()
        }
        reader.onerror = (error) => reject(error)
      })
    }

    await axios
      .post(`${window.MYQLOCX_API}/subject/admin/carriers/dbf`, body)
      .then(({ data }) => {
        setLoading(false)
        swalSuccess('Transportör skapad!', '', 'OK', `<div>email: ${data.email}<br/>lösenord: ${password}`)

        dispatch({ type: 'CREATE_CARRIER_SUCCESS', payload: data })

        setOrganization('')
        setEmail('')
        setPassword('')
        closeAddCarrierBox()
      })
      .catch((e) => {
        setLoading(false)
        if (e.response.data) swalError('Ajdå', e.response.data.message)
      })
  }

  const sortedVendors = vendors.map((c) => ({ label: c.name, value: c._id })).sort((a, b) => (a.label > b.label ? 1 : -1))

  return (
    <div style={{ background: '#fff', marginBottom: 20, padding: 7 }}>
      <input className="change-input form-control" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value.trim())} type="email" />
      <input className="change-input form-control" placeholder="Namn *" value={organization} onChange={(e) => setOrganization(e.target.value)} type="text" />
      <input className="change-input form-control" placeholder="Lösenord *" value={password} onChange={(e) => setPassword(e.target.value)} type="text" />
      <div>
        <div>Vendors</div>
        <Select noOptionsMessage={() => 'Tomt'} isMulti isClearable onChange={(list) => setSelectedVendors(list || [])} value={selectedVendors} options={sortedVendors} placeholder="Associerade leverantörer" />
      </div>
      <div style={{ padding: 10 }}>
        Bild (190x190 px)
        <input
          type="file"
          name={email}
          onChange={(e) => {
            const [file] = e.target.files

            const img = new Image()
            img.src = window.URL.createObjectURL(file)
            img.onload = () => {
              const { width, height } = img

              const largestSide = width > height ? width : height
              const ratio = largestSide / 190

              if (largestSide > 190) {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')

                if (width > height) {
                  canvas.width = 190
                  canvas.height = height / ratio
                } else {
                  canvas.height = 190
                  canvas.width = width / ratio
                }

                ctx.drawImage(img, 0, 0, 190, 190)

                const dataUrl = canvas.toDataURL('image/png')

                const size = dataUrl.length - (dataUrl.indexOf('base64') + 7)

                if (size > 1048576) return swalError('Fil för stor', 'Filen är större än 1MB')

                setFileData(dataURLtoFile(dataUrl, file.name))
              } else {
                if (file.size > 1048576) return swalError('Fil för stor', 'Filen är större än 1MB')

                setFileData(file)
              }
            }
          }}
          accept="image/*"
        />
        {fileData && (
          <div>
            <img src={URL.createObjectURL(fileData)} alt="carrier" />
          </div>
        )}
      </div>
      <Button
        disabled={!email || !password || loading}
        onClick={() => {
          addCarrier({
            email,
            organization,
            password: password && password,
          })
        }}
        className="btn btn-primary"
        bsSize="small"
        style={{ backgroundColor: '#006e78' }}
        block
      >
        <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara DBF-transportör
      </Button>
    </div>
  )
}

export default AddCarrierBox
